import "./HearingAidEligibilityInquiry.module.css";
import Header from "@/reusable_sections/Header";
import DataIntelligenceFutureHero from "./sections/DataIntelligenceFutureHero";
import WhoCanApplyForHearingAidSubsidies from "./sections/WhoCanApplyForHearingAidSubsidies";
import SubsidyQualificationConditions from "./sections/SubsidyQualificationConditions";
import SubsidyAmountExplanation from "./sections/SubsidyAmountExplanation";
import ApplicationProcessBrief from "./sections/ApplicationProcessBrief";
import CustomCareConsultation from "./sections/CustomCareConsultation";
import Footer from "@/reusable_sections/Footer";
export default function HearingAidEligibilityInquiryPage() {
  return <div>
      <Header />
      <DataIntelligenceFutureHero />
      <WhoCanApplyForHearingAidSubsidies />
      <SubsidyQualificationConditions />
      <SubsidyAmountExplanation />
      <ApplicationProcessBrief />
      <CustomCareConsultation />
      <Footer />
    </div>;
}